import SearchApi from "../api/search.api";
import * as actionTypes from "Consts/index";

export const get = (
    searchHits,
    query,
    take,
    skip,
    searchHitsText,
    culture,
    types,
    startPageId,
    currentPageId,
    takeNrFromPage,
    initial,
    totalHits,
    isMixedContent,
    orderByDate,
    categories,
    categoryTags,
    cleanResult
) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SEARCH__LOADING,
            payload: true,
        });
        if (initial) {
            dispatch({
                type: actionTypes.SEARCH__GET,
                payload: {
                    items: searchHits,
                    TotalCount: totalHits,
                    query: query,
                    culture: culture,
                    types: types,
                    startPageId: startPageId,
                    currentPageId: currentPageId,
                    searchHitsText: searchHitsText,
                    takeNrFromPage: takeNrFromPage,
                    isMixedContent: isMixedContent,
                    orderByDate: orderByDate,
                    categories: categories,
                    categoryTags: categoryTags,
                    cleanResult: cleanResult
                },
            });
            dispatch({
                type: actionTypes.SEARCH__LOADING,
                payload: false,
            });
            return;
        }
        SearchApi.getItems(
            query,
            take,
            skip,
            culture,
            types,
            startPageId,
            currentPageId,
            takeNrFromPage,
            isMixedContent,
            orderByDate,
            categories,
            categoryTags
        )
            .then((res) => {
                const {
                    SearchHits,
                    TotalHits,
                    IsMixedContent,
                    SearchQuery: {
                        Query,
                        CurrentCulture,
                        DocumentTypes,
                        CurrentPageId,
                        Skip,
                        StartPageId,
                        Take,
                        SearchHitsText,
                        TakeNrFromPage,
                        OrderByDate,
                        Categories,
                        CategoryTags
                    },
                } = res;
                dispatch({
                    type: actionTypes.SEARCH__GET,
                    payload: {
                        items: SearchHits,
                        TotalCount: TotalHits,
                        query: Query,
                        culture: CurrentCulture,
                        types: DocumentTypes,
                        startPageId: StartPageId,
                        currentPageId: CurrentPageId,
                        searchHitsText: SearchHitsText,
                        takeNrFromPage: TakeNrFromPage,
                        isMixedContent: IsMixedContent,
                        orderByDate: OrderByDate,
                        categories: Categories,
                        categoryTags: CategoryTags,
                        cleanResult: cleanResult
                    },
                });
                dispatch({
                    type: actionTypes.SEARCH__LOADING,
                    payload: false,
                });
            })
            .catch((e) => console.error(e));
    };
};

export const more = (
    searchHits,
    query,
    take,
    skip,
    searchHitsText,
    culture,
    types,
    startPageId,
    currentPageId,
    takeNrFromPage,
    initial,
    isMixedContent,
    orderByDate,
    categories,
    categoryTags,
    cleanResult
) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SEARCH__LOADING,
            payload: true,
        });
        SearchApi.getItems(
            query,
            take,
            skip,
            culture,
            types,
            startPageId,
            currentPageId,
            takeNrFromPage,
            isMixedContent,
            orderByDate,
            categories,
            categoryTags
        )
            .then((res) => {
                const {
                    SearchHits,
                    IsMixedContent,
                    TotalHits,
                    SearchQuery: {
                        Query,
                        CurrentCulture,
                        DocumentTypes,
                        CurrentPageId,
                        Skip,
                        StartPageId,
                        Take,
                        SearchHitsText,
                        TakeNrFromPage,
                        OrderByDate,
                        Categories,
                        CategoryTags
                    },
                } = res;
                dispatch({
                    type: actionTypes.SEARCH__MORE,
                    payload: {
                        items: SearchHits,
                        TotalCount: TotalHits,
                        query: Query,
                        culture: CurrentCulture,
                        types: DocumentTypes,
                        startPageId: StartPageId,
                        currentPageId: CurrentPageId,
                        searchHitsText: SearchHitsText,
                        takeNrFromPage: TakeNrFromPage,
                        isMixedContent: IsMixedContent,
                        orderByDate: OrderByDate,
                        categories: Categories,
                        categoryTags: CategoryTags,
                        cleanResult: cleanResult
                    },
                });
                dispatch({
                    type: actionTypes.SEARCH__LOADING,
                    payload: false,
                });
            })
            .catch((e) => console.error(e));
    };
};
